import { dateObjectToDateString, dateObjectToTimeString, dateObjectFromDateTimeStrings } from '@/services/dateTool';

interface IReleaseNote {
    id?: number | null;
    publishDateTime?: Date | null;
    subject?: string | null;
    notice?: string | null;
    isActive?: boolean | null;
    submitted?: string | null;
    submittedUserId?: number | null;
    updated?: string | null;
    updatedByUserId?: number | null;
}

class ReleaseNote implements IReleaseNote {
    public id?: number | null;
    public publishDate?: string | null;
    public publishTime?: string | null;
    public subject?: string | null;
    public notice?: string | null;
    public isActive?: boolean | null;
    public submitted?: string | null;
    public submittedUserId?: number | null;
    public updated?: string | null;
    public updatedByUserId?: number | null;
    public publishDateTimeAsNumber: number;
    public submittedDateAsNumber: number;

    constructor(m: IReleaseNote = {}) {
        this.id = m.id !== undefined ? m.id : null;
        const hasPublishDateTime: boolean = m.publishDateTime !== undefined && m.publishDateTime !== null;
        if (hasPublishDateTime) {
            const publishDateTime: Date = new Date(m.publishDateTime as Date);
            this.publishDate = dateObjectToDateString(publishDateTime);
            this.publishTime = dateObjectToTimeString(publishDateTime);
        } else {
            this.publishDate = null;
            this.publishTime = null;
        }
        this.subject = m.subject !== undefined ? m.subject : null;
        this.notice = m.notice !== undefined ? m.notice : null;
        this.isActive = m.isActive !== undefined ? m.isActive : null;
        this.submitted = m.submitted !== undefined && m.submitted !== null ? m.submitted : null;
        this.submittedUserId = m.submittedUserId !== undefined ? m.submittedUserId : null;
        this.updated = m.updated !== undefined && m.updated !== null ? m.updated : null;
        this.updatedByUserId = m.updatedByUserId !== undefined ? m.updatedByUserId : null;
        this.publishDateTimeAsNumber = this.setPublishDateTimeAsNumber();
        this.submittedDateAsNumber = this.setSubmittedDateAsNumber();
    }

    public get publishDateTime(): Date | null {
        if (this.publishDate !== undefined && this.publishDate !== null && this.publishDate.length > 8) {
            return dateObjectFromDateTimeStrings(this.publishDate, this.publishTime);
        } else {
            return null;
        }
    }

    public setPublishDateTimeAsNumber(): number {
        if (this.publishDateTime !== null) {
            return this.publishDateTime.getTime();
        } else {
            return -1;
        }
    }

    public setSubmittedDateAsNumber(): number {
        if (this.submitted !== undefined && this.submitted !== null) {
            return new Date(this.submitted).getTime();
        } else {
            return -1;
        }
    }
}

export default ReleaseNote;
export { ReleaseNote, IReleaseNote };
